export default function isKiosk() {
  return window.jamezzApplicationType === "KIOSK";
}
